export const REQUEST_PROFILE_WIDGET_DWELLERS_AND_LANDLORDS_HEADER_ACTIONS_VISIBILITY =
  {
    hidden: 'hidden',
    visible: 'visible',
  }
